export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Storage-10b827f8b157c225502a46dc6e53b3fb.webp";